<ion-content [fullscreen]="true">
  <ion-grid class="grid-full-screen with-field">
    <ion-row class="logo-row ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <img class="logo" src="../../assets/images/logo.png" />
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-item color="primary">
          <ion-label position="fixed" i18n>Username</ion-label>
          <ion-input
            type="text"
            name="username"
            [(ngModel)]="username"
            (keypress)="login($event.keyCode)"
            i18n-placeholder
            placeholder="Inserisci utente o email"
            autocomplete="off"
            color="secondary"
          ></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-item color="primary">
          <ion-label position="fixed" i18n>Password</ion-label>
          <ion-input
            type="password"
            name="password"
            [(ngModel)]="password"
            (keypress)="login($event.keyCode)"
            i18n-placeholder
            placeholder="Inserisci la password"
            autocomplete="off"
            color="secondary"
          ></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-button color="primary" expand="full" (click)="login()" i18n
          >Accedi</ion-button
        >
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-label class="custom-color" position="fixed" color="secondary" i18n
          >Oppure</ion-label
        >
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-button color="primary" expand="full" (click)="register()" i18n
          >Registrati</ion-button
        >
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-nav-link (click)="loginAsGuest()">
          <ion-label class="custom-color" color="secondary" i18n
            >Salta la registrazione per ora</ion-label
          >
        </ion-nav-link>
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-nav-link (click)="toggleResetPasswordForm()">
          <ion-label class="custom-color" color="secondary" i18n>Non ricordi la password?</ion-label>
        </ion-nav-link>
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center" *ngIf="showResetPasswordForm">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-item color="primary">
          <ion-label position="fixed" i18n>Email</ion-label>
          <ion-input
            type="email"
            name="email"
            [(ngModel)]="email"
            (keypress)="sendResetPasswordEmail($event.keyCode)"
            i18n-placeholder
            placeholder="Inserisci la tua email"
            autocomplete="off"
            color="secondary"
          ></ion-input>
        </ion-item>
        <ion-card
          color="danger"
          *ngIf="!!emailErrorMessage"
          class="ion-no-margin"
        >
          <ion-card-content class="ion-no-padding"
            >{{ emailErrorMessage }}</ion-card-content
          >
        </ion-card>
        <ion-button
          color="primary"
          expand="full"
          (click)="sendResetPasswordEmail()"
          i18n
          >VAI</ion-button
        >
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-nav-link>
          <ion-label
            class="custom-color"
            color="secondary"
            (click)="openTermsAndConditionsUrl()"
            i18n
            >Termini e condizioni</ion-label
          >
        </ion-nav-link>
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-nav-link>
          <ion-label
            class="custom-color"
            color="secondary"
            (click)="openPrivacyPolicyUrl()"
            i18n
            >Politica sulla privacy</ion-label
          >
        </ion-nav-link>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="spacer-150"></div>
</ion-content>
